import { handleActions } from 'redux-actions';
import { colors, logos } from 'shared/defaultTheme';
import { getHeaderFooterColorData } from 'shared/utils';
import {
  changeTheme,
  changeThemeToDark,
  changeThemeToLight,
  setClientLink,
} from '../actions/themeActions';

const defaultState = {
  className: 'theme-light',
  mainColor: colors.blueLefebvre,
  secondaryColor: colors.ecru,
  backgroundHeader: colors.white,
  backgroundFooter: colors.blueLefebvre,
  backgroundSideBar: colors.blueLefebvre,
  logoHeader: logos.lefebvre,
  whiteLogo: logos.lefebvreSmartWhite,
  logoFooter: logos.lefebvreSmartWhite,
  showLogoFooter: true,
  showNotifications: true,
  logoNotify: '',
  favicon: '',
  header: 0,
  footer: 0,
  syncContacts: null,
  lineColorHeader: colors.blueLefebvre,
  headerIconColor: colors.black,
  headerTextColor: colors.black,
  footerTextColor: colors.white,
  footerText:
    '<p>@ Lefebvre 2022. Todos los derechos reservados por. <a class="e-rte-anchor" href="https://lefebvre.es/contacto/" title="https://lefebvre.es/contacto/" target="_blank">Contacto</a>&nbsp; &nbsp;·&nbsp; <a class="e-rte-anchor" href="https://www.efl.es/?_ga=2.82753942.1858104048.1620917747-365385960.1620917746" title="https://www.efl.es/?_ga=2.82753942.1858104048.1620917747-365385960.1620917746" target="_blank">Tienda Online</a>&nbsp; ·&nbsp; <a class="e-rte-anchor" href="https://lefebvre.es/aviso-legal/" title="https://lefebvre.es/aviso-legal/" target="_blank">Aviso legal&nbsp;</a> ·&nbsp; <a class="e-rte-anchor" href="https://lefebvre.es/politica-de-cookies/" title="https://lefebvre.es/politica-de-cookies/" target="_blank">Política de cookies</a><br></p>',
  footerIconColor: colors.white,
  facebookLink: 'https://www.facebook.com/Lefebvre.ES/',
  linkedinLink: 'https://www.linkedin.com/company/lefebvre_es',
  youtubeLink: 'https://www.youtube.com/c/lefebvre_es',
  twitterLink: 'https://twitter.com/Lefebvre_ES',
  phone: '',
  title: '',
  hasClientLink: false,
};

export default handleActions(
  {
    [changeThemeToDark]() {
      return { className: 'theme-dark' };
    },
    [changeThemeToLight]() {
      return { className: 'theme-light' };
    },
    [setClientLink](state, action) {
      return { ...state, hasClientLink: action.payload };
    },
    [changeTheme](state, action) {
      const {
        logo,
        whiteLogo,
        logoNotify,
        favicon,
        colorPpal,
        colorSec,
        header,
        footer,
        syncContacts,
        phone,
        info,
        linkYoutube,
        linkTwitter,
        linkFacebook,
        linkLinkedin,
        showLogoFooter,
        showNotifications,
        title,
        socialReason,
      } = action.payload;
      const headerDataColor = getHeaderFooterColorData(header, colorPpal, logo, whiteLogo);
      const footerDataColor = getHeaderFooterColorData(footer, colorPpal, logo, whiteLogo);

      return {
        ...state,
        mainColor: colorPpal || state.mainColor,
        secondaryColor: colorSec || state.secondaryColor,
        backgroundHeader: headerDataColor?.backgroundColor || state.backgroundHeader,
        backgroundFooter: footerDataColor?.backgroundColor || state.backgroundFooter,
        backgroundSideBar: colorPpal,
        logoHeader: headerDataColor?.logo || state.logoHeader,
        whiteLogo: whiteLogo || state.whiteLogo,
        logoFooter: footerDataColor?.logo || state.logoFooter,
        logoNotify: logoNotify || state.logoNotify,
        favicon: favicon || state.favicon,
        header: header || state.header,
        footer: footer || state.footer,
        syncContacts: syncContacts || state.syncContacts,
        lineColorHeader: colorSec || state.lineColorHeader,
        headerIconColor: headerDataColor?.iconColor || state.headerIconColor,
        headerTextColor: headerDataColor?.textColor || state.headerTextColor,
        footerTextColor: footerDataColor?.textColor || state.footerTextColor,
        footerText: info || state.footerText,
        footerIconColor: footerDataColor?.iconColor || state.footerIconColor,
        youtubeLink: linkYoutube || state.youtubeLink,
        twitterLink: linkTwitter || state.twitterLink,
        facebookLink: linkFacebook || state.facebookLink,
        linkedinLink: linkLinkedin || state.linkedinLink,
        phone: phone || state.phone,
        title: title || state.title,
        socialReason: socialReason || state.socialReason,
        showLogoFooter: showLogoFooter || state.showLogoFooter,
        showNotifications: showNotifications || state.showNotifications,
      };
    },
  },
  defaultState
);
